<template>
    <div :class="classes">
        <div :class="theme.line"></div>
        <div v-if="isRenderContent" :class="theme.container">
            <slot></slot>
        </div>
    </div>
</template>

<script>
    import { vAnimationHeight } from '../AnimationHeight';
    import theme from './stepper.scss';

    export default {
        name: 'stepper-content',
        props: {
            step: Number,
            theme: {
                type: Object,
                default() {
                    return theme;
                }
            }
        },
        components: {
            vAnimationHeight
        },
        computed: {
            currentStep() {
                return this.$parent.step;
            },
            isRenderContent() {
                return this.currentStep === this.step;
            },
            classes() {
                return {
                    [this.theme.content]: true,
                    [this.theme.isRender]: this.isRenderContent,
                }
            }
        }
    }
</script>


// WEBPACK FOOTER //
// StepperContent.vue?060f4dfe